const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/events/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/events/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    postTo: z.uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "New Event Draft",
      description: "Page title for CMS new event draft page"
    })
  }
});